<template>
  <AppButton 
    :class="[{ active }]" 
    :size="size" 
    outline 
    @click="onClick"
  >
    <IconSpinner v-if="!options || !options.length"/>
    <template v-else>
      <IconShevron/>
      <ul>
        <li 
          v-for="option in options"
          :key="option[keyword]"
          :class="{ active: option[keyword] === value }"
          @click="onChange(option)"
        >
          <slot name="option" :option="option"/>
        </li>
      </ul>
    </template>
  </AppButton>
</template>


<script>
import AppButton from './AppButton';
import IconSpinner from '@icons/IconSpinner';
import IconShevron from '@icons/IconShevron';

export default {
  name: 'AppSelect',

  components: {
    AppButton,
    IconSpinner,
    IconShevron,
  },

  props: {
    keyword: {
      type: String,
      default: 'id',
    },
    value: String,
    options: {
      type: [Array, Object],
      default: () => [],
    },
    size: {
      type: String,
      default: 'big',
    },
  },

  data: () => ({
    active: false,
  }),

  methods: {
    onClick() {
      this.active = !this.active;
    },
    onChange(option) {
      if (!this.active) return;
      this.$emit('change', option[this.keyword]);
    },
  },
};
</script>


<style lang="scss" scoped>
button {
  display: flex;
  flex-direction: column;
  align-items: center;

//   @media (hover: hover) {
//     cursor: pointer;
//     transition: background-color .2s;
//     &:hover {
//       background-color: #0001;
//     }
//   }

  & > svg {
    &.spinner {
      justify-self: center;
      align-self: center;
    }

    &.shevron {
      position: absolute;
      height: 100%;
      right: 16px;
      top: 1px;
      font-size: 12px;
      pointer-events: none;
      transition: transform .1s;
      z-index: 1;
    }
  }

  &.active {
    & > svg.shevron {
      transform: rotate(180deg);
    }

    @media (hover: hover) {
      ul li:hover {
        color: var(--color-white);
      }
    }
  }

  &:not(.active) ul li:not(.active) {
    display: none;
  }

  &.big {
    border-radius: 26px;
    ul {
      padding: 15px 0;
      gap: 16px;
    }
  }

  &.small {
    border-radius: 8px;
    ul {
      padding: 12px 1em 12px 0;
      gap: 12px;
    }
  }

  ul {
    min-height: 100%;
    box-sizing: border-box;
    border-radius: inherit;
    margin: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: inherit;
    box-shadow: inherit;

    li {
      list-style: none;
      width: auto;
      font-family: Arial, Helvetica, sans-serif;
      font-weight: bold;
    }
  } 
}
</style>